import Vue from "vue";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";
import "firebase/analytics";

var config = {
  apiKey: "AIzaSyDniQiM56IKhQ-UaeHZcM2BHjqxFW5XuRU",
  authDomain: "telfersadmin.firebaseapp.com",
  databaseURL: "https://telfersadmin.firebaseio.com",
  projectId: "telfersadmin",
  storageBucket: "telfersadmin.appspot.com",
  messagingSenderId: "765665117065",
  appId: "1:765665117065:web:861abdf8fab69014019758",
  measurementId: "G-7MRPPJK99H"
};

// let host = window.location.host;
// if (
//   host == "localhost:8080" ||
//   host == "localhost:8081" ||
//   host == "localhost:8082" ||
//   host == "192.168.178.21:8080" ||
//   host == "192.168.178.21:8081" ||
//   host == "192.168.178.21:8082" ||
//   host == "10.0.0.9:8080" ||
//   host == "DomainOfDev" ||
//   host.substring(0, 4) == "dev."
// ) {
//   var config = {};
// }

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let cloneFunction = function(obj) {
  return JSON.parse(JSON.stringify(obj));
};

firebase.analytics();
Vue.prototype.analytics = firebase.analytics();
export const clone = cloneFunction;
export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const dataB = firebase.database();
export const DB = firebase.firestore();
export const files = firebase.storage().ref();
export const driverRef = DB.collection("Drivers");
export default firebase;
